import React from 'react';

import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { SizeProp } from '@fortawesome/fontawesome-svg-core';

interface BiaSpinnerProps {
  className?: string;
  style?: React.CSSProperties;
  size?: SizeProp;
}

const BiaSpinner: React.FC<BiaSpinnerProps> = ({ className = "", style={}, size = "sm" }) => (
 <FontAwesomeIcon 
    icon={faSpinner} 
    style={{ color: '#97999b',
      ...style
     }}
    size={size}
    spin
    className={className} />
);

export default BiaSpinner;
